import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import lineService from '@/services/line';

export const KEY_LOGIN_STATE = 'LoginState';

const Page = styled.div`
  min-height: 100vh;
`;

const OAuthLogin = () => {
  const {
    pathname: pathName,
    state: routerState,
  } = useLocation();
  const { provider } = useParams();

  React.useEffect(() => {
    let loginUrl = pathName;

    const loginId = new Date().getTime();
    try {
      // NOTE: Try to store the state to the local storage to let
      // oAuthCallback be able to read.
      localStorage.setItem(KEY_LOGIN_STATE, JSON.stringify({
        ...routerState,
        loginId,
      } || { loginId }));
    } catch (error) {
      // This operation is optional, we could just ignore this error.
    }

    switch (provider) {
      case 'line':
        loginUrl = lineService.getLoginUrl(loginId);
        break;
      default:
        break;
    }
    window.location.href = loginUrl;
  }, [pathName, routerState, provider]);

  return <Page />;
};

export default OAuthLogin;
